import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b1d8c064")

_pushScopeId("data-v-b1d8c064")
const _hoisted_1 = { class: "toc_ui__reminder_main" }
const _hoisted_2 = { class: "toc_ui__reminder_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_4 = {
  key: 0,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "1.除事故检测、泡水检测、火烧检测、发动机、变速箱外，其余检测项目结果仅反应检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode("4.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件、发动机、变速器做深度拆解；"),
  /*#__PURE__*/_createVNode("br")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "5.腾发检测标准符合国家二手车鉴定标准和CADA团体标准，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-0606-777咨询。", -1)
const _hoisted_13 = {
  key: 1,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "1.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "2.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "3.本报告检测内容仅供参考，不可直接作为车辆交易凭证，如您参考此报告购车，腾发不承担任何检测失误的责任；", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "4.腾发检测标准符合国家二手车鉴定标准和CADA团体标准，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-0606-777咨询。", -1)
const _hoisted_21 = { class: "toc_ui__anti_body" }
const _hoisted_22 = { class: "toc_ui__anti_farkurl" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farktext" }, "识别二维码查看报告真伪", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _hoisted_20
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _createVNode("img", {
          src: _ctx.state.antiFakeUrl
        }, null, 8, ["src"])
      ]),
      _hoisted_23
    ], 512), [
      [_vShow, _ctx.state.antiFakeUrl && _ctx.state.isShowAntiFake]
    ])
  ]))
})